<!--
 * @Description: 全部商家页面组件
 -->
<template>
  <div class="shoplist-page">
    <div class="page-container">
    <!-- 分类标签区域 -->
    <div class="category-section">
      <div class="category-group">
        <span class="category-label">市场</span>
        <div class="category-tabs">
          <div
            class="tab-item"
            :class="{ active: query.area_id === '0' }"
            @click="changeArea('0')"
          >
            全部
          </div>
          <div
            class="tab-item"
            :class="{ active: query.area_id === '1' }"
            @click="changeArea('1')"
          >
            五亭龙
          </div>
        </div>
      </div>
      <div class="category-group">
        <span class="category-label">类别</span>
        <div class="category-tabs">
          <div
            v-for="(type, i) in types"
            :key="i"
            class="tab-item"
            :class="{ active: query.type === type.id }"
            @click="changeType(type.id)"
          >
            {{ type.name }}
          </div>
        </div>
      </div>
    </div>
    <!-- 分类标签END -->

    <!-- 筛选区域 -->
    <div class="filter-section">
      <div class="filter-tags">
        <div
          class="filter-tag"
          :class="{ active: sort === '' }"
          @click="changeSort('')"
        >
          综合
        </div>
        <div
          class="filter-tag"
          :class="{ active: sort === 'views' }"
          @click="changeSort('views')"
        >
          浏览量
        </div>
        <div
          class="filter-tag"
          :class="{ active: sort === 'sales' }"
          @click="changeSort('sales')"
        >
          销量
        </div>
      </div>
      <div class="pagination-top">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="query.pageSize"
          :current-page="query.page"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 筛选END -->

    <!-- 主要内容区 -->
    <div class="products-section" v-loading="loading" element-loading-text="加载中">
      <div class="shop-list" v-if="list.length > 0">
        <div
          class="shop-card"
          v-for="(item, k) in list"
          :key="k"
        >
          <!-- 商家信息 - 左侧 -->
          <div class="shop-info-section">
            <div class="shop-header">
              <div class="shop-info">
                <h3 class="shop-name">
                  {{ item.CName }}
                  <span class="shop-year">{{ item.comeInYear }}年店</span>
                </h3>
                <p class="shop-addr">{{ item.Addr }}</p>
              </div>
              <div class="shop-badge">
                <span class="daifa-tag">代</span>
              </div>
            </div>

            <!-- 商家详细信息 -->
            <div class="shop-detail">
              <div class="detail-item">
                <span class="label">有货：</span>
                <span class="value">{{ item.totalGoods }}款</span>
              </div>
              <div class="detail-item">
                <span class="label">电话：</span>
                <span class="value">{{ item.Mobile }}</span>
              </div>
              <div class="detail-item">
                <span class="label">QQ：</span>
                <span class="value">{{ item.QQ }}</span>
              </div>
            </div>

            <!-- 商家统计 -->
            <div class="shop-stats">
              <div class="stat-item">
                <div class="stat-value">{{ item.saleCount }}</div>
                <div class="stat-label">年销量</div>
              </div>
              <div class="stat-item">
                <div class="stat-value good">0-5%</div>
                <div class="stat-label">退货率</div>
              </div>
              <div class="stat-item">
                <div class="stat-value good">0-5%</div>
                <div class="stat-label">缺货率</div>
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="shop-actions">
              <router-link
                :to="{ path: '/shop', query: { SID: item.ID } }"
                target="_blank"
              >
                <el-button type="danger" size="mini">进入查看</el-button>
              </router-link>
              <el-button type="primary" size="mini" plain>收藏</el-button>
              <el-button type="warning" size="mini" plain>联系</el-button>
            </div>
          </div>

          <!-- 商品展示 - 右侧 -->
          <div class="shop-goods-section">
            <el-carousel
              :interval="5000"
              arrow="always"
              height="160px"
              v-if="item.goods.length > 4"
              indicator-position="none"
            >
              <el-carousel-item v-for="i in [0, 1]" :key="i">
                <div class="goods-row">
                  <div
                    v-for="(goods, gk) in item.groupGoodsList[i]"
                    :key="gk"
                    class="goods-item"
                  >
                    <router-link
                      :to="{ path: '/detail', query: { id: goods.ID } }"
                      target="_blank"
                    >
                      <el-image
                        :src="$target + '/UpLoad/' + goods.Path + '/' + goods.FName"
                        class="goods-img"
                      ></el-image>
                      <div class="goods-name">{{ goods.PName }}</div>
                      <div class="goods-views">{{ goods.HotNum }}人看</div>
                    </router-link>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="goods-row" v-else>
              <div
                v-for="(goods, gk) in item.goods"
                :key="gk"
                class="goods-item"
              >
                <router-link
                  :to="{ path: '/detail', query: { id: goods.ID } }"
                  target="_blank"
                >
                  <el-image
                    :src="$target + '/UpLoad/' + goods.Path + '/' + goods.FName"
                    class="goods-img"
                  ></el-image>
                  <div class="goods-name">{{ goods.PName }}</div>
                  <div class="goods-views">{{ goods.HotNum }}人看</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty-state">
        <p>暂无商家信息</p>
      </div>

      <!-- 底部分页 -->
      <div class="pagination-section">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="query.pageSize"
          :current-page="query.page"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
    </div>
    <!-- 主要内容区END -->
  </div>
</template>
<script>
export default {
  name: "ShopList",
  components: {},
  data() {
    return {
      types: [
        { id: "0", name: "全部" },
        { id: "1", name: "动物类毛绒" },
        { id: "2", name: "综合类毛绒" },
        { id: "3", name: "植物类毛绒" },
        { id: "4", name: "人物类毛绒" },
        { id: "5", name: "毛绒抱枕" },
        { id: "6", name: "公仔类" },
        { id: "7", name: "家具日用品" },
        { id: "8", name: "服装鞋袜帽包" },
        { id: "9", name: "鞋袜" },
        { id: "10", name: "毛绒坐垫" },
        { id: "11", name: "服装" },
      ],
      dateRange: "",
      loading: true,
      list: [], // 商家列表
      total: 50, // 商家总量
      currentPage: 1, //当前页码
      sort: '',
      query: {
        area_id: "0",
        type: "0",
        pageSize: 10,
        page: 1,
      },
    };
  },
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    /**
     * 切换市场
     * @param {*} id
     */
    changeArea(id) {
      this.loading = true;
      this.query.area_id = id;
      this.query.page = 1;
      this.getData();
    },
    /**
     * 切换类别
     * @param {*} index
     */
    changeType(index) {
      this.loading = true;
      this.query.type = index;
      this.query.page = 1;
      this.getData();
    },
    /**
     * 切换排序
     * @param {*} s
     */
    changeSort(s) {
      this.loading = true;
      this.sort = s;
      this.query.page = 1;
      this.getData();
    },
    /**
     * 变更页码
     * @param {*} currentPage
     */
    currentChange(currentPage) {
      this.loading = true;
      this.query.page = currentPage;
      this.getData();
    },
    /**
     * 获取列表数据
     */
    async getData() {
      const queryString =
        "area_id=" +
        this.query.area_id +
        "&type=" +
        this.query.type +
        "&page=" +
        this.query.page +
        "&sort=" +
        this.sort;
      const { data } = await this.$axios.get(
        this.$newApi + "/api/rbh/supply/list?" + queryString
      );
      let list = data.data.list.map((shop) => {
        const goods = shop.goods;
        let groupGoods = [];
        if (goods.length > 4) {
          groupGoods.push(goods.slice(0, 4));
          groupGoods.push(goods.slice(4));
        }
        shop.groupGoodsList = groupGoods;
        return shop;
      });
      this.list = list;
      this.total = data.data.totalCount;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.shoplist-page {
  background: #f5f7fa;
  min-height: 100vh;
  padding: 15px 0;
}

/* 页面容器 - 与首页一致的宽度 */
.shoplist-page .page-container {
  width: 1240px;
  margin: 0 auto;
}

/* 分类标签区域 */
.category-section {
  background: white;
  border-radius: 12px;
  padding: 12px 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.category-group {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.category-group:last-child {
  margin-bottom: 0;
}

.category-label {
  width: 45px;
  font-size: 13px;
  font-weight: 600;
  color: #666;
}

.category-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tab-item {
  padding: 5px 14px;
  background: #f8f9fa;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 13px;
  color: #666;
}

.tab-item:hover {
  background: #fff5f5;
  color: #ff6b6b;
}

.tab-item.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
}

/* 筛选区域 */
.filter-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: white;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.filter-tags {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-tag {
  padding: 6px 12px;
  background: #f8f9fa;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 13px;
  color: #666;
}

.filter-tag:hover {
  background: #fff5f5;
  color: #ff6b6b;
}

.filter-tag.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
}

.pagination-top .el-pagination {
  padding: 5px 10px;
}

/* 商家列表区域 */
.products-section {
  min-height: 500px;
  background: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.shop-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.shop-card {
  display: flex;
  background: white;
  border-radius: 10px;
  border: 1px solid #eee;
  overflow: hidden;
  transition: all 0.3s ease;
}

.shop-card:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* 商家信息区域 - 左侧 */
.shop-info-section {
  width: 320px;
  flex-shrink: 0;
  padding: 12px;
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
}

.shop-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.shop-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
}

.shop-year {
  font-size: 11px;
  color: #783400;
  padding: 1px 5px;
  background: #fbde2d;
  border-radius: 3px;
  margin-left: 6px;
  font-weight: normal;
}

.shop-addr {
  font-size: 12px;
  color: #999;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shop-badge {
  flex-shrink: 0;
}

.daifa-tag {
  display: inline-block;
  padding: 3px 6px;
  background: linear-gradient(135deg, #9e51ed 0%, #8a3fd3 100%);
  color: #fff;
  font-size: 11px;
  border-radius: 3px;
}

.shop-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eee;
}

.detail-item {
  font-size: 12px;
  color: #666;
}

.detail-item .label {
  color: #999;
}

.shop-stats {
  display: flex;
  margin-bottom: 8px;
}

.stat-item {
  flex: 1;
  text-align: center;
}

.stat-value {
  font-size: 15px;
  font-weight: 600;
  color: #ff6b6b;
}

.stat-value.good {
  color: #2ea067;
}

.stat-label {
  font-size: 11px;
  color: #999;
}

.shop-actions {
  display: flex;
  gap: 6px;
}

.shop-actions .el-button {
  flex: 1;
  padding: 4px 8px;
  font-size: 12px;
}

/* 商品展示区域 - 右侧 */
.shop-goods-section {
  flex: 1;
  padding: 10px;
  background: #fafafa;
}

.goods-row {
  display: flex;
  gap: 8px;
}

.goods-item {
  flex: 1;
  text-align: center;
  padding: 6px;
  background: white;
  border-radius: 6px;
  border: 1px solid #eee;
  transition: all 0.3s ease;
}

.goods-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.goods-img {
  width: 100px;
  height: 100px;
  border-radius: 6px;
}

.goods-name {
  font-size: 12px;
  color: #333;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.goods-views {
  font-size: 11px;
  color: #ff6b6b;
  margin-top: 2px;
}

/* 轮播图箭头样式 */
.shop-goods-section /deep/ .el-carousel__arrow {
  width: 24px;
  height: 24px;
  font-size: 12px;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 0;
}

.empty-state img {
  width: 200px;
  height: 200px;
  opacity: 0.6;
  margin-bottom: 20px;
}

.empty-state p {
  font-size: 16px;
  color: #999;
}

/* 分页区域 */
.pagination-section {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.pagination-section .el-pagination {
  padding: 10px 20px;
  background: white;
  border-radius: 25px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.pagination-section .el-pagination.is-background .el-pager li {
  border-radius: 50%;
  margin: 0 3px;
}

.pagination-section .el-pagination.is-background .el-pager li.active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
}
</style>
